import { Faqs } from 'types/event/eventStep5'
import { create } from 'zustand'

const eventCommonStoreState = (set: any) => ({
  // modal
  faqModalOpen: false,
  setFaqModalOpen: (state: boolean) =>
    set(() => ({
      faqModalOpen: state,
    })),
  addQuestionModal: false,
  setAddQuestionModal: (state: boolean) =>
    set(() => ({ addQuestionModal: state })),
  addDocument: false,
  setAddDocument: (state: boolean) => set(() => ({ addDocument: state })),

  // data sets
  faqData: undefined,
  setFaqData: (state: Faqs | undefined) => set(() => ({ faqData: state })),
  selectedQuestions: [],
  setSelectedQuestions: (state: string[]) =>
    set(() => ({
      selectedQuestions: state,
    })),
  mentorShifts: [],
  setMentorShifts: state =>
    set(() => ({
      mentorShifts: state,
    })),
})

export const eventCommonStore = create(eventCommonStoreState)
